<template>
  <ErrorPage 
    code="403"
    title="errors.403_title"
    message="errors.403_message"
  />
</template>

<script>
import ErrorPage from "@/layouts/ErrorPage.vue"

export default {
  name: "Error403",
  components: { ErrorPage }
}
</script>
